export const VERIFICATION_PAGE_TITLE =
    'Manta Rays inspire us. These beautiful animals harness the power of the ocean and glide through stormy water.';
export const GETTING_STARTED = 'Getting started';
export const VERIFY_ACCOUNT = 'Verify your account';
export const DID_NOT_RECEIVE_CODE = 'Didn’t receive a code?';
export const RESEND_CODE = `Resend`;
export const VERIFY = 'Verify';
export const CONTINUE = 'Continue';
export const PLEASE_ENTER_YOUR_EMAIL = 'Please enter the code sent to your email';
export const CHECK_SPAM_FOLDER = 'Check your spam folder as well.';
export const CSRF_TOKEN = 'csrf_token';
export const INVALID_CODE =
    "Whoops. That doesn't seem right. Please re-enter the code from the email. If you need a new code, click on Resend code.";
export const VERIFICATION_CODE = 'Verification Code';
export const PLEASE_TRY_AGAIN = 'Something goes wrong, please try again by resending token';
export const BACK = 'Back';
export const NO_QUESTIONS_OR_PAGE_INFO_AVAILABLE = 'No questions or page information available';
export const LOGIN = 'Log in';
export const LOGOUT = 'Log out';
export const DO_NOT_YOU_HAVE_ACCOUNT = `Don't have an account?`;
export const SIGN_UP = 'Sign up';
export const WELCOME_BACK_TO_YOUR_JOURNEY = 'Transforming how we manage and experience cancer.';
export const WELCOME_BACK = 'Welcome back';
export const LOGIN_TO_MANTA_CARE_ACCOUNT = 'Log into your account';
export const EMAIL_ADDRESS = 'Email address';
export const CREATE_YOUR_ACCOUNT = 'Create your account';
export const ALREADY_HAVE_AN_ACCOUNT = 'Already have an account?';
export const PASSWORD = 'Password';
export const EMAIL_REQUIRED = 'Email is required';
export const INVALID_EMAIL = "Whoops! The email you entered isn't quite right. Mind checking it again? Thanks!";
export const PASSWORD_REQUIRED = 'Password is required';
export const CONFIRM = 'Confirm';
export const TERMS_AND_CONDITION = 'Terms & Conditions.';
export const PRIVACY_POLICY = 'Privacy Policy';
export const DONATE_YOUR_EXPERIENCES_TO_RESEARCH = 'Donate your experiences to research.';
export const CONGRATULATION_ON_JOINING_OUR_COMMUNITY = 'Congratulations on joining our community. ';
export const THIS_IS_THE_FIRST_STEP_TOWARDS_JOURNEY = 'This is the first step towards your healthy journey.';
export const THANKS = 'Thanks!';
export const YOU_ARE_NOT_ALONE = 'You are not alone.';
export const YOUR_COMMUNITY_WITH_YOU = 'Your community is with you.';
export const TELL_ABOUT_YOU = 'We need a few details.';
export const WHAT_SHOULD_WE_CALL_YOU = 'What should we call you?';
export const PHONE_NUMBER = 'Phone Number';
export const PLEASE_ENTER_VALID_PHONE_NUMBER = 'Oops. We need a valid phone number. Can you try that again?';
export const UNKNOWN_ERROR_OCCURRED = 'An unknown error occurred.';
export const FORGOT_PASSWORD = 'Forgot Password';
export const FORGOT_PASSWORD_QUESTION = 'Forgot Password?';
export const DO_NOT_WORRY_ENTER_YOUR_EMAIL = 'Don’t Worry! Fill in your email and we’ll send you a code to reset your password.';
export const ENTER_YOUR_EMAIL = 'Enter your email';
export const SEND_EMAIL = 'Send Email';
export const RESET_PASSWORD = 'Reset Password';
export const CHANGE_PASSWORD = 'Change Password';
export const PASSWORD_NOT_MATCHING = "Oops! Password and Confirm Password don't match. Mind trying that again? Thanks!";
export const PLEASE_ENTER_CODE_SENT_TO_YOUR_EMAIL = 'Please enter the code sent to your email';
export const RECOVER_YOUR_ACCOUNT = 'Recover your account';
export const CONFIRM_PASSWORD = 'Confirm Password';
export const CONFIRM_NEW_PASSWORD = 'Confirm New Password';
export const NEW_PASSWORD = 'New Password';
export const RESET_PASSWORD_CODE_TEXT = 'Please type in a new password to log in to the platform.';
export const PASSWORD_CHANGED_SUCCESSFULLY = 'Your password has been successfully updated.';
export const ENTER_YOUR_CODE = 'Enter your code';
export const UNABLE_TO_CONNECT_TO_SERVER = "Oops! We can't reach the server right now. Please try again later. Thanks!";
export const ACCOUNT_VERIFIED = 'Account Verified!';
export const YOU_WILL_BE_NAVIGATED_TO_LOGIN = 'You can log in again in';
export const NAME_MAX_LENGTH = 'Name should not contain more than 70 characters';
export const NAME_CHARACTER_ERROR = 'Name should contain at least one alphabet';
export const GETTING_KNOW_YOU = 'Getting to know you';
export const GETTING_KNOW_YOU_SUBTITLE = 'Before we assign you a map, we need to know what type of cancer you have.';
export const PLEASE_FILL_NAME = 'Hey there! What should we call you? Could you kindly fill that in? We appreciate it!';
export const MAP_ASSIGNMENT = 'Map Assignment';
export const MAP_ASSIGNMENT_SUBTITLE = 'Before we assign you a map, we need to know what type of cancer you have';
export const LAST_STEP = 'Last step';
export const SELECT_YOUR_MAP = 'Select Your Map';
export const SELECT_YOUR_MAP_SUBTITLE = 'Please select which map best corresponds to your experience and click next';
export const SELECT_YOUR_MAP_SUBTITLE_2 = `Click "Assign my map later" if you don't want a map right now or "I don't know..." if you need help finding your map.`;
export const I_DONT_KNOW_WHICH_MAP = "I don't know which map to choose";
export const DONT_KNOW_WHICH_MAP_DIALOG_TITLE = "Don't know which map to choose?";
export const DONT_KNOW_WHICH_MAP_DIALOG_CONTENT =
    'Thank you for letting us know! Someone from the Manta Cares team will reach out after this onboarding to help you find the appropriate map.';
export const SELECT_MAP_LATER = 'I want to select my map later';
export const DONT_KNOW_WHICH_MAP_HELPER_TEXT =
    'If you’re unsure which map to select, click either button to move on. You can choose a map later.';
export const SELECT_YOUR_PHASE = 'Select Your Phase';
export const SELECT_YOUR_PHASE_SUBTITLE =
    "For the map you selected, select which phase of the cancer experience you're currently going through";
export const PLEASE_FILL_PHONE_NUMBER = 'Hey there! We need your number to keep your account safe.';
export const PLEASE_FILL_OTP_EMAIL = 'Oops! Please enter the code sent to your email.';

export const WE_ARE_WITH_YOU = 'We are with you, each step of the way.';
export const WELCOME_TO_MANTACARES_COMMUNITY =
    'Welcome to our community of patients, survivors, caregivers, family members, and providers.';
export const TERMS_AND_CONDITION_LINK = 'https://mantacares.com/pages/manta-cares-digital-terms-of-use';
export const PRIVACY_POLICY_LINK = 'https://mantacares.com/pages/manta-cares-digital-privacy-policy';
export const INCOMPLETE_ONBOARDING =
    'We noticed you left without completing the process. Please complete your onboarding to unlock all the features.';
export const TIMER = 5000;
export const ALREADY_REGISTERED_EMAIL = 'An account with the same email already exists. Please log in.';
export const SOMETHING_WENT_WRONG = 'Something went wrong, please try again.';
export const TERMS_AND_CONDITIONS_LONG =
    'By clicking this box, you acknowledge and agree that you have read, understood, and agree to Manta Cares’ Terms of Services available';
export const HERE = 'here.';
export const REGION_HELPER_TEXT = 'Select the region of the cancer';
export const CUSTOM_DIAGNOSIS = 'Type your diagnosis here';
export const WELCOME_TO_MANTACARES = 'Welcome to Manta Cares!';
export const CONGRATULATION_ON_TAKING_FIRST_STEP = 'Congratulations on taking the first step in your journey with Manta Cares!';
export const SUPPORT_YOU_EVERY_STEP =
    'We’re here to support you every step of the way, providing tools and resources to help you navigate cancer with confidence.';
export const CLICK_THE_VIDEO_TO_LEARN_MORE = 'Click the video to learn more about our maps or click a button below to start exploring.';
export const EXPLORE_MAP = 'Explore Map';
export const SELECT_MY_MAP = 'Select my map';
export const USE_GEARS = 'Use Gears';
export const DIGITAL_TOOLS_FOR_MANAGING_YOUR_CARE = 'Digital tools for managing your care';
export const GO_TO_HOME = 'Go to Home';
export const SEE_GUIDES = 'See Guides';
export const GUIDES_ORGANIZED_BY_CATEGORY_AND_CANCER_TYPE = 'Resource guide organized by category and cancer type';
export const PERSONALIZING_CONTENT = 'Personalizing your account now';
